module.exports = __webpack_public_path__ + "img/rapid.e18476d4.svg";